<template>

    <div class="ha">

        <button class="ha__btn"
                :class="{
            'ha__active': category === ENUM.NEWSLETTERS.CATEGORIES.AUTO_DELETE,
            'text-lMedium': category !== ENUM.NEWSLETTERS.CATEGORIES.AUTO_DELETE,
            'text-lSemibold': category === ENUM.NEWSLETTERS.CATEGORIES.AUTO_DELETE,
        }"
                @click="updateCategory(ENUM.NEWSLETTERS.CATEGORIES.AUTO_DELETE)">
            <p class="mr__6">{{ $t('my_actions_autodelete') }}</p>
            <div class="ha__highlight">
                <p class="text-baseMedium">{{ blocked }}</p>
            </div>
        </button>

        <button class="ha__btn"
                :class="{
            'ha__active': category === ENUM.NEWSLETTERS.CATEGORIES.KEEP,
            'text-lMedium': category !== ENUM.NEWSLETTERS.CATEGORIES.KEEP,
            'text-lSemibold': category === ENUM.NEWSLETTERS.CATEGORIES.KEEP,
        }"
                @click="updateCategory(ENUM.NEWSLETTERS.CATEGORIES.KEEP)">
            <p class="mr__6">{{ $t('my_actions_keep') }}</p>
            <div class="ha__highlight">
                <p class="text-baseMedium">{{ kept }}</p>
            </div>
        </button>
    </div>

</template>

<script>

import ENUM from '@/assets/ENUM'

export default {

    name: 'newsletters-header-categories',

    props: {

        category: {
            type: String,
            default: ''
        },

        blocked: {
            type: Number,
            default: 0
        },
        kept: {
            type: Number,
            default: 0
        }
    },

    computed: {
        ENUM() {
            return ENUM
        }
    },

    methods: {
        updateCategory(newCategory) {
            this.$emit('updateCategory', newCategory)
        }
    }
}
</script>

<style lang="scss" scoped>

.ha {
    display: flex;
    flex-direction: row;

    &__btn {
        display: flex;
        flex: 1;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: $timberwolf;
        padding: 8px 16px;
        border-bottom: 2px solid $timberwolf;

        @media screen and (min-width: $above-tablet-length) {
            border-bottom: none;
            background-color: $white;
        }
    }

    &__active {
        border-bottom: 2px solid $aquamarine;
        @media screen and (min-width: $above-tablet-length) {
            border-bottom: none;
            background-color: $timberwolf;
            border-radius: 72px;
        }
    }

    &__highlight {
        padding: 4px;
        background-color: $aquamarine;
        color: $white;
        border-radius: 72px;
        min-width: 24px;
    }
}
</style>
